module.exports = __webpack_public_path__ + "static/media/the-descent-by-kevin-macleod-from-filmmusic-io.338b4856.mp3";